import { quickFacts, usageSteps } from "@/mocks/siteContent";

export default function Overview() {
  return (
    <section id="overview" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs font-medium text-primary-600 bg-primary-50 px-3 py-1 rounded-full mb-4">
            <i className="ri-compass-3-line" aria-hidden="true"></i>
            题材总览
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
            同一组情感与伦理命题，三种载体给出三种答案
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            以「邻居的妻子」为题的短剧、小说与电影，共享相近的冲突内核，却因为时长、媒介和叙事节奏不同，把重点放在了完全不同的地方。搞清楚这些差异，你就能快速判断自己更吃哪一种口味，而不必一部一部试错。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
          {quickFacts.map((fact) => (
            <article
              key={fact.title}
              className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70 transition-colors hover:border-accent-300"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-700 mb-4">
                <i className={`${fact.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-950">{fact.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{fact.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-8 bg-secondary-50 rounded-lg p-6 md:p-8 border border-secondary-200/70">
          <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 flex items-center gap-2">
            <i className="ri-guide-line text-secondary-600" aria-hidden="true"></i>
            这份整理怎么用
          </h3>
          <ul className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-3">
            {usageSteps.map((step) => (
              <li key={step} className="flex items-start gap-3 text-sm text-foreground-700 leading-relaxed">
                <i className="ri-checkbox-circle-line text-secondary-600 mt-0.5 shrink-0" aria-hidden="true"></i>
                <span>{step}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}